/**
 * Platform owner (super-admin) identity.
 *
 * These emails get god-mode access to everything across all companies. The same
 * list is enforced server-side in firestore.rules via request.auth.token.email,
 * so it cannot be spoofed from the client. Keep the two in sync.
 */
export const OWNER_EMAILS = ['mikegio1111@gmail.com'];

export const isOwnerEmail = (email?: string | null): boolean =>
  !!email && OWNER_EMAILS.includes(email.toLowerCase());
